import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Briefcase, Moon, Zap, User, Heart, Target } from 'lucide-react';
const cases = [{
  icon: User,
  text: 'Knee stiffness'
}, {
  icon: Activity,
  text: 'Leg heaviness'
}, {
  icon: Zap,
  text: 'Lower back tension'
}, {
  icon: Briefcase,
  text: 'Shoulder tightness'
}, {
  icon: Moon,
  text: 'Neck stiffness'
}, {
  icon: Heart,
  text: 'Joint discomfort'
}, {
  icon: Target,
  text: 'Muscle tightness from stress or posture'
}];
export function BodyReliefUseCasesSection() {
  return <section className="py-8 sm:py-12 bg-bone" data-id="element-301">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-302">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-6 sm:mb-8" data-id="element-303">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-charcoal mb-4 tracking-tight" data-id="element-304">
            Built for Real Bodies. Real Routines.
          </h2>
          <p className="text-sm sm:text-base text-charcoal-light font-light" data-id="element-305">
            GINEXT is used daily by people dealing with:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-306">
          {cases.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-4 rounded-xl shadow-sm border border-bone-dark flex items-center gap-3" data-id="element-307">
              <div className="w-8 h-8 bg-ginger/10 rounded-full flex items-center justify-center text-ginger flex-shrink-0" data-id="element-308">
                <item.icon className="w-4 h-4" data-id="element-309" />
              </div>
              <span className="text-sm sm:text-base font-light text-charcoal" data-id="element-310">
                {item.text}
              </span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-6 sm:mt-8 text-sm sm:text-base text-charcoal-light italic font-light" data-id="element-311">
          This isn't emergency relief. It's daily support that prevents buildup.
        </motion.p>
      </div>
    </section>;
}